import ColorBlock from "./ColorBlock";
import { BLOCKCOLORS } from "../../constants";

import React from "react";

const ColorBlocks = () => {
  return (
    <>
      {Object.keys(BLOCKCOLORS).map((color, index) => {
        const height = 100 / 7;
        const animationDelay = index * 0.17; // Increment the delay based on the index
        return (
          <ColorBlock
            key={color}
            height={height}
            animationDelay={animationDelay}
            color={BLOCKCOLORS[color]}
          />
        );
      })}
    </>
  );
};

export default ColorBlocks;
